import "./Line.scss";
export default function LineClone(props) {
  return (
    <div
      className={`line-container editable`}
    >
      <div className="line-buttons">
        <span>Čiara</span>
      </div>
      {(props.line === "solid")
        &&
        <div className="line line-solid">
        </div>
      }
      {(props.line === "dotted")
        &&
        <div className="line line-dotted">
        </div>
      }
      {(props.line === "dashed")
        &&
        <div className="line line-dashed">
        </div>
      }
      {(props.line === "double")
        &&
        <div className="line line-double">
        </div>
      }
      {(props.line === "empty")
        &&
        <div className="line">
        </div>
      }
    </div>
  );
}
